<template>
  <div class="nft_list">
    <div
      v-if="isConnected && listSize > 0"
      @click="toggleTable"
      class="flex justify-end"
    >
      <img src="@/assets/img/icons/heart-box.svg" class="h-8 cursor-pointer" />
    </div>
    <div>
      <div v-if="isConnected && listSize > 0" class="px-2 md:px-0">
        <div
          class="flex flex-col flex-wrap md:flex-row md:-mx-3 md:justify-start items-start mt-6 text-center"
        >
          <div class="w-full" v-if="showTable">
            <div
              class="mb-6 leading-loose tracking-widest flex flex-col justify-center"
            >
              <span class="">
                1 - Approve (only once) our contract as caretaker for every vNFT
                you want to multi feed or multi mine.</span
              >
              <span class="">
                2 - Next time you can multi mine and multi feed with one tx
              </span>
            </div>

            <table class="table-auto w-full border border-gray-900">
              <thead>
                <tr>
                  <th class="px-4 py-2">Vnft</th>
                  <th class="px-4 py-2">Name</th>
                  <th class="px-4 py-2">Can Mine</th>
                  <th class="px-4 py-2">TOD</th>
                  <th class="px-4 py-2">Gem</th>
                </tr>
              </thead>
              <tbody
                class="border border-gray-900"
                v-for="nft in nfts"
                :key="nft.id"
              >
                <NFTTools :contract="nft.contract" :id="nft.id" />
              </tbody>
            </table>
            <div class="flex">
              <button
                class="cursor-pointer btn focus:outline-none flex items-center justify-center w-64"
                @click="mineAll"
              >
                <img src="@/assets/img/vnftLogo.svg" class="h-8 px-2" />
                <span class="px-2 inline-block">Mine Selected</span>
              </button>
              <button
                class="cursor-pointer btn focus:outline-none flex items-center justify-center w-64 ml-4"
                @click="feedAll"
              >
                <img src="@/assets/img/vnftLogo.svg" class="h-8 px-2" />
                <span class="px-2 inline-block">Feed all</span>
              </button>
            </div>
          </div>
          <div
            v-else
            class="md:w-1/4 w-4/5 p-3 md:px-3"
            v-for="nft in nfts"
            :key="nft.id"
            v-on:click="clickNFT(nft.contract, nft.id)"
          >
            <NFT :contract="nft.contract" :id="nft.id" />
          </div>
        </div>
      </div>
      <div v-else class="text-center text-2xl mt-10">
        You don't have any vNFTs yet.
        <router-link to="/mint" class="hover:text-blue-400"
          >Mint one</router-link
        >
        ,
        <router-link to="/wrap" class="hover:text-blue-400"
          >Wrap one</router-link
        >
        , or buy one in
        <a
          href="https://opensea.io/assets/vnft"
          target="_blank"
          class="hover:text-blue-400"
        >
          Open Sea</a
        >.
      </div>
    </div>

    <ConnectWallet />
  </div>
</template>

<script>
import ConnectWallet from "@/components/ConnectWallet.vue";
import NFT from "@/components/NFT.vue";
import NFTTools from "@/components/NFTTools.vue";

export default {
  name: "NFTList",
  components: { ConnectWallet, NFT, NFTTools },
  data: function () {
    return {
      nfts: [],
      isLoading: true,
      listSize: 0,
      onClicked: Function,
      showTable: false,
      nftsCanMine: [],
      loader: null,
      gems: [],
      hasTokenApproval: false,
    };
  },
  methods: {
    clickNFT: function (contract, id) {
      console.log("click");
      this.$emit("NFTClick", contract, id);
    },
    fetchNFTS: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      console.log(this.$store.state.account);

      this.listSize = await this.$store.state.vNFTContract.methods
        .balanceOf(this.$store.state.account)
        .call();
      let tokens = [];
      for (let index = 0; index < this.listSize; index++) {
        console.log(index);
        let id = await this.$store.state.vNFTContract.methods
          .tokenOfOwnerByIndex(this.$store.state.account, index)
          .call();
        tokens.push({
          id: id,
          contract: this.$store.state.account.toLowerCase(),
        });
      }
      this.nfts = tokens;
    },
    toggleTable: function () {
      this.showTable = !this.showTable;
    },
    // canMine: function (params) {
    //   alert(params);
    // },
    mineAll: async function () {
      // get array of id's available to mine
      this.nftsCanMine = [];
      for (const nft of this.nfts) {
        const id = nft.id;
        let infos = await this.$store.state.vNFTContract.methods
          .getVnftInfo(id)
          .call();

        const lastTimeMined = parseInt(infos._lastTimeMined);

        console.log(lastTimeMined);

        let nextMining = lastTimeMined + 60 * 60 * 24;
        let currentTime = Math.floor(Date.now() / 1000);

        // console.log(nextMining);
        // console.log(currentTime);

        const canMine = nextMining < currentTime;
        // const canMine = true; for tests
        console.log("can", canMine);

        let selectedToMine = document.querySelectorAll("#mine");
        let wantToMineArr = [];
        for (const wantToMine of selectedToMine) {
          if (wantToMine.checked)
            wantToMineArr.push(parseInt(wantToMine.getAttribute("data-id")));
        }

        console.log(wantToMineArr);

        if (canMine) {
          this.nftsCanMine.push(parseInt(id + ""));
        }

        this.nftsCanMine = this.nftsCanMine.filter((el) =>
          wantToMineArr.includes(el)
        );

        console.log("canMnine", this.nftsCanMine);
      }

      if (this.nftsCanMine.length == 0) {
        alert(`Check at least 1 pet to mine under the "Can Mine" column`);
      } else {
        // uncomment this to mine
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
          // execute multi mining
          console.log(this.nftsCanMine);
          let multiclaim = await this.$store.state.MultiVnftContract.methods
            .claimMultiple(this.nftsCanMine)
            .send({
              from: this.$store.state.account,
            });

          this.loader.hide();

          this.$notify({
            group: "foo",
            title: "Success",
            text: `You claimed Muse for all your pets!.`,
            type: "success",
          });
        } catch (e) {
          console.log(e);
          this.loader.hide();
          this.$notify({
            group: "foo",
            title: "Error",
            text: `There was an error with the tx`,
            type: "error",
          });
        }
      }
    },
    feedAll: async function () {
      // get all gems
      //@todo add matching ids
      this.gems = [];
      const gemsPicked = document.querySelectorAll(".feed-gem");

      for (const gem of gemsPicked) {
        if (gem.value != "null") {
          let id = gem.getAttribute("data-nftId");
          this.gems.push({ nftId: id, gemId: gem.value });
        }
      }

      console.log(this.gems);

      if (!this.hasTokenApproval) {
        await this.approve();
      }

      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        let nftIds = [];
        let gemIds = [];
        for (const g of this.gems) {
          nftIds.push(g.nftId);
          gemIds.push(g.gemId);
        }

        let multiFeed = await this.$store.state.MultiVnftContract.methods
          .feedMultiple(nftIds, gemIds)
          .send({
            from: this.$store.state.account,
          });

        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `You claimed Muse for all your pets!.`,
          type: "success",
        });
      } catch (e) {
        console.log(e);
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let remove = "0";
      let approve = await this.$store.state.MuseTokenContract.methods
        .approve(this.$store.state.contracts.MultiVnft, max)
        .send({
          from: this.$store.state.account,
        });
    },
    init: async function () {
      this.hasTokenApproval =
        (
          await this.$store.state.MuseTokenContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.MultiVnft
            )
            .call()
        ).length >= 18;

      console.log("token approval", this.hasTokenApproval);
    },
  },
  mounted: function () {
    this.init();
  },
  beforeMount: function () {
    this.fetchNFTS();
  },
  watch: {
    isConnected: function () {
      this.fetchNFTS();
      this.init();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
